import { api } from './api';

export const getStudents = (params?: { search?: string; cursor?: string; limit?: number }) =>
  api.get('/admin/users', { params: { ...params, role: 'STUDENT' } });
